<template>
  <div>
    <Toolbar class="p-mb-4">
      <template slot="left">
        <Button
          label="Add Project Type"
          icon="pi pi-plus"
          class="p-button-success p-mr-2"
          @click="openNewTypesForm"
        />
      </template>
      <template slot="right">
        <span class="p-input-icon-left">
          <i class="pi pi-search" />
          <InputText v-model="filters['global']" placeholder="Global Search" />
        </span>
      </template>
    </Toolbar>
    <DataTable
      :value="projectTypes"
      :paginator="true"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="25"
      dataKey="contactId"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[5, 10, 25]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Related Accounts"
    >
      <template #header>
        <div class="table-header">Related Project Types.</div>
      </template>

      <template #empty> No Related Project Types. Accounts found! </template>
      <template #loading>
        Loading Related Project Types. Please wait.
      </template>
      <Column field="id" header="Id" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.id ? slotProps.data.id : "" }}
        </template>
      </Column>
      <Column field="projTypeCode" header="Display Order" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.projTypeCode ? slotProps.data.projTypeCode : "" }}
        </template>
      </Column>
      <Column field="projTypeName" header="Description" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.projTypeName ? slotProps.data.projTypeName : "" }}
        </template>
      </Column>
      <Column field="active" header="Active" :sortable="true">
        <template #body="slotProps">
          <span v-if="slotProps.data.active">YES</span>
          <span v-else>NO</span>
        </template>
      </Column>
      <Column headerStyle="width: 10em;">
        <template #body="slotProps">
          <div :style="{ position: 'relative' }">
            <SplitButton
              label="Edit"
              icon="pi pi-pencil"
              class="p-button-success p-mb-2"
              @click="editProjectTypes(slotProps.data)"
              :model="getButtons(slotProps.data)"
            >
            </SplitButton>
          </div>
        </template>
      </Column>
    </DataTable>
    <Dialog
      :visible.sync="projectTypesForm"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Project Types"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col relative">
          <label for="noteHeader">Display Order:</label>
          <InputText
            id="noteHeader"
            v-model.trim="projectType.projTypeCode"
            required="true"
            autofocus
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="noteDetails">Description:</label>
          <InputText
            placeholder=""
            :disabled="false"
            :autoResize="true"
            rows="6"
            v-model="projectType.projTypeName"
          />
        </div>
        <div class="p-field p-col">
          <label for="noteDetails">Active:</label>
          <SelectButton
            v-model="projectType.active"
            :options="options"
            optionLabel="label"
            optionValue="value"
          />
        </div>
      </div>
      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
          @click="projectTypesForm = false"
        />
        <Button
          label="Save"
          icon="pi pi-check"
          class="p-button-text"
          @click="save"
        />
      </template>
    </Dialog>
    <Dialog
      header="Confirmation"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px', overflowY: 'auto' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>Do you wish to delete the Project Types?</span>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeConfirmation"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="deleteProjectType"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import OpportunityService from "@/service/OpportunityService";
import PermissionMixin from "../PermissionMixin.vue";
export default {
  mixins: [PermissionMixin],
  opportunityService: null,
  data: () => ({
    projectTypesForm: false,
    displayConfirmation: false,
    loading: true,
    filters: {},
    projectTypes: null,
    projectType: {},
    options: [
      { value: true, label: "yes" },
      { value: false, label: "no" }
    ]
  }),
  methods: {
    getButtons(data) {
      this.checkPermissions();
      let buttons = [];
      if (this.deleteSettings) {
        buttons.push({
          label: "Delete",
          icon: "pi pi-trash",
          command: () => {
            this.openConfirmation(data);
          }
        });
      }
      return buttons;
    },
    openNewTypesForm() {
      this.projectType = {};
      this.projectTypesForm = true;
    },
    openConfirmation(data) {
      this.projectType = data;
      this.displayConfirmation = true;
    },
    closeConfirmation() {
      this.displayConfirmation = false;
    },
    editProjectTypes(data) {
      this.projectType = data;
      this.projectTypesForm = true;
    },
    async deleteProjectType() {
      this.closeConfirmation();
      await this.opportunityService.deleteProjectTypes(this.projectType.id);
      this.$toast.add({
        severity: "success",
        summary: "Success Message",
        detail: "Project type removed",
        life: 5000
      });
      this.getAllProjectTypes();
      this.getAllActiveProjectTypesByHard();
    },
    save() {
      if (!this.projectType.id) {
        this.opportunityService
          .postProjectTypes(this.projectType)
          .then(res => {
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Project type added",
              life: 5000
            });
            this.getAllProjectTypes();
            this.getAllActiveProjectTypesByHard();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving project type",
              life: 5000
            });
          });
      } else {
        this.opportunityService
          .putProjectTypes(this.projectType, this.projectType.id)
          .then(res => {
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Project type updated",
              life: 5000
            });
            this.getAllProjectTypes();
            this.getAllActiveProjectTypesByHard();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating project type",
              life: 5000
            });
          });
      }
      this.projectTypesForm = false;
    },
    getAllProjectTypes() {
      this.loading = true;

      this.opportunityService
        .getAllProjectTypesByHard()
        .then(data => {
          this.projectTypes = data;
          this.loading = false;
        })
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting project types",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "projecttypes"'
          });
        });
    },
    getAllActiveProjectTypesByHard() {
      this.opportunityService
        .getAllActiveProjectTypesByHard()
        .then(data => {})
        .catch(err => {
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "activeProjectTypes"'
          });
        });
    }
  },
  created() {
    this.opportunityService = new OpportunityService();
  },
  mounted() {
    this.getAllProjectTypes();
  }
};
</script>
